import Vue, { ComponentOptions } from 'vue'

export default {
  components: {},
} as ComponentOptions<Vue>
